// vue3-migration -- Element
import langBn from './element_bn';
import translations from './translations.json';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langBn,
};
